import { SvgIconReact } from "components/SvgIconReact/SvgIconReact";
import { modalIds } from "constants/modals-constants";
import { useModal } from "hooks/useModal";
import type React from "react";
import { useTranslation } from "react-i18next";
import {
  type AccessibilityButtonVariant,
  StyledAccessibilityMenuButton,
} from "./AccessibilityMenuButton.styled";

interface AccessibilityMenuButtonProps {
  className?: string;
  variant?: AccessibilityButtonVariant;
}

export const AccessibilityMenuButton: React.FC<AccessibilityMenuButtonProps> = ({
  className,
  variant = "header",
}) => {
  const { t } = useTranslation("common");
  const { toggleModal } = useModal();

  const toggleAccessibilityModal = (event: React.MouseEvent) => {
    event.stopPropagation();
    toggleModal(modalIds.modalAccessibilityMenu);
  };

  return (
    <StyledAccessibilityMenuButton
      $variant={variant}
      aria-label={t("header.button.accessibility")}
      className={className}
      data-cy="open-accessibility-menu-button"
      variant="text"
      onClick={toggleAccessibilityModal}
    >
      <SvgIconReact iconName="accessibilityIcon" size={1.4} />
      <span>{t("header.button.label", "Accessibility")}</span>
    </StyledAccessibilityMenuButton>
  );
};
